<script setup lang="ts">
import { AppSelectSearchable } from '@shared/ui/selects'

import { useSelectPaidEla } from '../../model/payment-policy/select-paid-ela.hook'

defineOptions({
  name: 'SelectPaidEla',
})

const {
  modelValue,
  label,
  placeholder,
  options,
  hasMore,
  loading,
  selectedOption,
  disabled,
  onSearch,
  onLoadMore,
  onOpen,
} = useSelectPaidEla()
</script>

<template>
  <AppSelectSearchable
    v-model="modelValue"
    :options="options"
    :label="label"
    :placeholder="placeholder"
    :selected-option="selectedOption"
    :has-more="hasMore"
    :loading="loading"
    :disabled="disabled"
    clearable
    infinite
    @search="onSearch"
    @load-more="onLoadMore"
    @open="onOpen"
  />
</template>
